import { render } from "./backTop.vue?vue&type=template&id=b46d73a6&scoped=true"
const script = {}

import "./backTop.vue?vue&type=style&index=0&id=b46d73a6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b46d73a6"]])

export default __exports__